import { render, staticRenderFns } from "./app-content-layout.vue?vue&type=template&id=5332632e&scoped=true&"
import script from "./app-content-layout.vue?vue&type=script&lang=js&"
export * from "./app-content-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332632e",
  null
  
)

export default component.exports